document.addEventListener('alpine:init', () => {
  Alpine.data('CollectionGridItems', () => ({
    mq_mobile: window.matchMedia("(max-width: 600px)"),
    init() {
      let am = this;
      // am.$el.classList.remove('productgrid-listview', 'productgrid-gridview')
      am.UpdateView()
      am.mq_mobile.addEventListener('change', am.UpdateView.bind(am))
    },
    UpdateView() {
      let am = this;
      let is_mobile = am.mq_mobile.matches

      let is_list_active = am.$el.classList.contains('productgrid-listview')
      let is_grid_active = am.$el.classList.contains('productgrid-gridview')

      let urlParams = new URLSearchParams(window.location.search);
      let url_view = urlParams.get('grid_list');
      // console.log(url_view)

      if (!url_view) {
        am.$el.classList.remove('productgrid-listview', 'productgrid-gridview')
  
        if (is_mobile && !is_grid_active) {
          am.$el.classList.add('productgrid-gridview')

          // toggle button
          am.$el.querySelectorAll('.utils-viewtoggle-button').forEach($item => {
            $item.classList.remove('active')
          })  
          am.$el.querySelector('.utils-viewtoggle-button[data-collection-view="grid-view"]').classList.add('active')
        }
        if (!is_mobile && !is_list_active) {
          am.$el.classList.add('productgrid-listview')

          // toggle button
          am.$el.querySelectorAll('.utils-viewtoggle-button').forEach($item => {
            $item.classList.remove('active')
          })  
          am.$el.querySelector('.utils-viewtoggle-button[data-collection-view="list-view"]').classList.add('active')
        }  
      }
    }
  }));
});